import gql from 'graphql-tag'
import client from '../../stores/apollo'
import { FetchResult } from 'apollo-link'
import { IFloorMapSpace } from '@api/types'

type IBookMeetingRoom = {
  viewer: {
    company: {
      spaceConnection: {
        edges: IFloorMapSpace[]
      }
    }
  }
}

export default function fetchMeetingRoom(
  toDate: string,
  fromDate: string,
  floorId: string | null,
  assignmentPlanId: string,
  spaceTypeId_in: string[] | null
): Promise<FetchResult<IBookMeetingRoom>> {
  const variables = {
    toDate,
    fromDate,
    where: {
      AND: [
        {
          floorId,
          assignmentPlanId,
          spaceTypeId_in,
        },
      ],
    },
  }

  return client.gql.query({ query, variables })
}

export const query = gql`
  query spaceStuff($where: SpaceWhereInput, $fromDate: String!, $toDate: String!) {
    viewer {
      company {
        spaceConnection(where: $where) {
          edges {
            node {
              id
              dailyBookableSpacesAvailability(fromDate: $fromDate, toDate: $toDate) {
                availability
                bookings {
                  ... on CalendarEvent {
                    startDate
                    endDate
                    summary
                  }
                }
              }
              calendar {
                calendarEvents {
                  id
                }
              }
              w
              x
              y
              code
              capacity
              density
              externalId
              name
              comment
              floor {
                building {
                  city
                  state
                  country
                }
              }
              spaceAssignment {
                team {
                  id
                  name
                }
                department {
                  id
                  name
                }
                employee {
                  id
                  name
                }
                sharedEmployees {
                  id
                  name
                }
              }
              workplaceGroup {
                id
                name
              }
              usageType {
                name
              }
              spaceType {
                name
                interactivityType
              }
              tags {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`
